import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import './style/site.style.sass';

import CommonModule from 'common';
import SceneModule from './scene';

export default angular
    .module('legal', [
        uiRouter,

        CommonModule.name,
        SceneModule.name
    ])
    .config(routerConfiguration);

/* @ngInject */
function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/privacy-policy');
}



// WEBPACK FOOTER //
// ./src/legal/index.js